import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";

export default function MobileAlerts({ notes }) {
  const nav = useNavigate();
  const open = async (n) => {
    await notes.markRead(n);
    if (n.link) nav(n.link);
    else if (n.lead_id) nav("/crm/indiamart");
  };
  return (
    <div className="pb-6" data-testid="mobile-alerts">
      <div className="flex items-center justify-between px-3 pt-3 pb-2">
        <h1 className="text-[20px] font-bold" style={{ fontFamily: "Manrope" }}>Alerts</h1>
        {notes.unreadCount > 0 && (
          <button type="button" onClick={notes.markAllRead} className="h-11 px-2 text-[14px] text-[var(--m-link)]">Mark all read</button>
        )}
      </div>
      {!notes.loaded && (
        <div className="px-3 space-y-2" aria-busy="true">
          {[0, 1, 2].map((i) => <div key={i} className="m-skeleton h-16" />)}
        </div>
      )}
      {notes.loaded && notes.items.length === 0 && (
        <div className="p-8 text-center text-[var(--m-muted)]">
          <Bell className="w-8 h-8 mx-auto opacity-60" />
          <div className="mt-2 text-[15px] font-semibold text-[var(--m-text)]">No notifications</div>
          <div className="text-[13px] mt-1">You're all caught up.</div>
        </div>
      )}
      {notes.items.length > 0 && (
        <div className="divide-y divide-[var(--m-border)] border-y border-[var(--m-border)]">
          {notes.items.map((n) => (
            <button key={n.id} type="button" onClick={() => open(n)}
              className="w-full min-h-[56px] text-left px-3 py-2.5 bg-[var(--m-card)] active:bg-[var(--m-skeleton)] flex gap-2.5">
              <span className="mt-1.5 shrink-0 w-2 h-2 rounded-full" style={{ background: n.read ? "transparent" : "var(--m-accent)" }} />
              <span className="min-w-0">
                <span className={`block text-[14px] ${n.read ? "" : "font-semibold"}`}>{n.title}</span>
                {n.body && <span className="block text-[13px] text-[var(--m-muted)]">{n.body}</span>}
                {n.created_at && <span className="block text-[11px] text-[var(--m-muted)] mt-0.5">{new Date(n.created_at).toLocaleString()}</span>}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
